import { ChangeEvent, FC, memo } from "react";

import Label from "@/components/atoms/inputForms/Label";

interface Props {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  /** Applied to <input> when fullRow is false; applied to wrapping <label> when fullRow is true. */
  className?: string;
  labelClassName?: string;
  id?: string;
  disabled?: boolean;
  label?: string;
  /** When true, root is a single <label> wrapping input + text so the whole row/tile is clickable. */
  fullRow?: boolean;
}

const TILE_INPUT_CLASS =
  "my-0.5 h-[18px] w-[18px] shrink-0 border-theme-medium focus:ring-2 focus:ring-primary-thin";

const CheckboxBase: FC<Props> = ({
  onChange,
  checked,
  className,
  labelClassName,
  id,
  disabled,
  label,
  fullRow,
}) => {
  if (fullRow) {
    return (
      <label
        htmlFor={id}
        className={[
          "flex min-w-0 items-center gap-2",
          disabled ? "cursor-not-allowed" : "cursor-pointer",
          className ?? "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <input
          className={`${TILE_INPUT_CLASS} ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
          checked={checked}
          onChange={onChange}
          type="checkbox"
          id={id}
          disabled={disabled}
        />
        {label ? (
          <span className={[`min-w-0`, labelClassName].filter(Boolean).join(" ")}>{label}</span>
        ) : null}
      </label>
    );
  }

  const classNames = ["", className].filter(Boolean).join(" ");

  return (
    <>
      <input
        className={classNames}
        checked={checked}
        onChange={onChange}
        type="checkbox"
        id={id}
        disabled={disabled}
      />
      {label && (
        <Label
          classNames={labelClassName}
          label={label}
          disabled={disabled}
          htmlFor={id}
        />
      )}
    </>
  );
};

export const Checkbox = memo(CheckboxBase);
